import * as React from 'react'
import Svg from '../Svg'
export const SvgUser = (props: React.SVGProps<SVGSVGElement>) => (
    <Svg
        viewBox="0 0 85.8 85"
        fill="#000"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        {...props}
    >
        <path d="M42.9 45c10.6 0 19.2-10 19.2-22.5C62.1 5.3 53.5 0 42.9 0S23.7 5.3 23.7 22.5C23.7 35 32.3 45 42.9 45zM85.4 78.2l-9.7-21.9c-.4-1-1.2-1.8-2.2-2.3l-15.1-7.8c-.3-.2-.7-.1-1 .1-4.3 3.2-9.3 4.9-14.5 4.9s-10.2-1.7-14.5-4.9c-.3-.2-.7-.3-1-.1L12.3 54c-1 .5-1.7 1.3-2.2 2.3L.4 78.2c-.7 1.5-.5 3.2.4 4.6.9 1.4 2.4 2.2 4.1 2.2H81c1.6 0 3.2-.8 4.1-2.2.8-1.4 1-3.1.3-4.6z" />
    </Svg>
)
SvgUser.isIcon = true
export default SvgUser
